import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@redux/reducers/rootReducer';

const savedViewsDisposalsState = (state: RootState) => state.savedViews.disposals;

const getState = createSelector(savedViewsDisposalsState, (state) => state);
const unpinnedSavedView = createSelector(savedViewsDisposalsState, (state) => state.unpinnedActiveSavedView);

export const savedViewsDisposalsSelectors = {
  getState,
  unpinnedSavedView,
};
